export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Floating%20abstract%20geometric%20shapes%20in%20warm%20coral%20terracotta%20and%20soft%20cream%20beige%20tones%20arranged%20in%20a%20modern%20minimalist%20data%20visualization%20composition%2C%20ethereal%20glowing%20nodes%20connected%20by%20delicate%20lines%20suggesting%20spreadsheet%20grid%20patterns%2C%20soft%20gradient%20background%20blending%20sage%20green%20and%20warm%20sand%2C%20sophisticated%20tech%20art%20aesthetic%20with%20organic%20flowing%20forms%2C%20editorial%20quality%20digital%20illustration%20with%20dreamy%20atmosphere%20and%20gentle%20luminous%20effects&width=1600&height=900&seq=hero-bg-v2-litbuy&orientation=landscape"
          alt="Litbuy Spreadsheet modern data visualization concept"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium mb-4 md:mb-6 border border-background-50/20">
          Trusted Spreadsheet Resource
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
          Litbuy Spreadsheet<br />
          <span className="text-accent-300">Guides &amp; Resources</span>
        </h1>
        <p className="text-background-50/80 text-sm md:text-base max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Your complete resource for Litbuy Spreadsheet tutorials, comparisons, and expert guides. Learn how to maximize your productivity with the right spreadsheet tools.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all"
          >
            litbuy spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/25 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-all"
          >
            Buy It Now
          </a>
        </div>
      </div>

      <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-background-50/60 text-xl animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}